import SavingsPolicyOptions from "../datasets/savings_policy_options";

export const addToTotalTranTypeArr = (savingsType, savingsClass, tranYear, currentPrice, tranArrObj, 
        tranSort, totalByTranTypeArr) => {
    let tranYearIndx = totalByTranTypeArr.findIndex(elem => elem.savingsType + elem.tranYear +
            elem.tranType === savingsType + tranYear + tranArrObj.tranType );
    let typeSortValue = "z";
    const savingsPolicyObj = SavingsPolicyOptions.find(elem => elem.type === savingsType);
    if (savingsPolicyObj){
        typeSortValue = savingsPolicyObj.sortValue;
    }
    if (tranYearIndx === -1){
        let className = false;
        if (tranArrObj.className){
            className = tranArrObj.className;
        }
        let balFwdSw = tranArrObj.balFwdSw;
        if (tranYear === "all"){
            balFwdSw = false;
        }
        let totalObj = {savingsType: savingsType, tranYear: tranYear, 
            tranType: tranArrObj.tranType, tranAmt: +tranArrObj.tranAmt,
            typeSortValue: typeSortValue, className: className,
            tranSort: tranSort, balFwdSw: balFwdSw};
        if (savingsClass === "retirement" && tranArrObj.tranType !== "Federal Income Tax - Transfer"){
            const shareQuantity =(+tranArrObj.shareQuantity).toFixed(4);
            tranArrObj.shareQuantity = shareQuantity;
          //  const tranAmt = (+tranArrObj.shareQuantity * +currentPrice).toFixed(4);
          //  totalObj.tranAmt = +tranAmt;
            totalObj = {...totalObj, shareQuantity: +tranArrObj.shareQuantity, sharePrice: currentPrice }
        }
        totalByTranTypeArr.push(totalObj);
    }else{
        if (savingsClass === "retirement" && tranArrObj.tranType !== "Federal Income Tax - Transfer"){
            const shareQuantity =(+tranArrObj.shareQuantity).toFixed(4);
            tranArrObj.shareQuantity = shareQuantity;
         //   tranAmt = (+shareQuantity * +currentPrice).toFixed(4);
            totalByTranTypeArr[tranYearIndx].shareQuantity =
                (+totalByTranTypeArr[tranYearIndx].shareQuantity + +tranArrObj.shareQuantity).toFixed(4);
        }
        //const tranAmt = (+tranAmt + +tranArrObj.tranAmt).toFixed(4);
        totalByTranTypeArr[tranYearIndx].tranAmt += +tranArrObj.tranAmt;
    }
}
export default addToTotalTranTypeArr;
